import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PotxSvg = function PotxSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M20.5 20.25a.75.75 0 0 1-.75.75H8v.75a.25.25 0 0 0 .25.25h13a.25.25 0 0 0 .25-.25v-18h.25V3.5l-1.5-1v1.75h.25z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M6.75 20.5h13a.25.25 0 0 0 .25-.25v-16H6.5v16a.25.25 0 0 0 .25.25"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#605E5C",
      d: "M21.5 4v17.75a.25.25 0 0 1-.25.25h-13a.25.25 0 0 1-.25-.25V21h11.75a.75.75 0 0 0 .75-.75v-16H20v16a.25.25 0 0 1-.25.25h-13a.25.25 0 0 1-.25-.25v-16H6v16c0 .413.337.75.75.75h.75v.75c0 .413.337.75.75.75h13a.75.75 0 0 0 .75-.75V4z",
      opacity: 0.64
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FF8F6B",
      d: "M20.5 1.549a.5.5 0 0 0-.207-.049H6.5A.5.5 0 0 0 6 2v2l.25.25h14L20.5 4v-.625l.25-.25V2.25z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#ED6C47",
      fillRule: "evenodd",
      d: "M20.927 3.427 22 4.5V3.207a.5.5 0 0 0-.146-.354l-1.207-1.207a.5.5 0 0 0-.147-.098v2.055a.25.25 0 0 1 .427-.176M6 4h14.5v.5H6zm9 8 .5.5h3v.25a3.25 3.25 0 0 1-4.5 3V12.5l.5-.5z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FF8F6B",
      d: "M15.25 9.5c-.444 0-.865.09-1.25.252V12.5h1.5v-3z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FFC7B5",
      d: "M16.5 8.5v3h3a3 3 0 0 0-3-3"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C43E1C",
      d: "M3 18.5h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F9F7F7",
      fillRule: "evenodd",
      d: "M9.442 10.481Q8.884 10 7.834 10H5.5v6h1.145v-2.121H7.76q.67 0 1.18-.253.507-.254.785-.71.275-.456.275-1.042 0-.911-.558-1.393M7.63 12.963h-.985v-2.034h1.022q1.127 0 1.127.992 0 .51-.294.776t-.87.266",
      clipRule: "evenodd"
    })]
  });
};
export var Potx = function Potx(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: PotxSvg
  }));
};